
import { UPDATE_CHASSIDATA, UPDATE_SPAREPARTDATA ,UPDATE_CHASSILOADING, CLEAR_CHASSIDATA, ERROR_CHASSIDATA}  from '../constants';
const defaultState = { 
  isloading:false  ,
  isDataerror:false,
  chassiSearchList:[],
  errors: [],
  pageInitialized:true
};
export const chassisearch = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {       
        case UPDATE_SPAREPARTDATA:
        if(!payload)
            state = defaultState    
        return {
                ...state,              
                chassiSearchList: payload,
                errors: payload.Errors,
                pageInitialized:false
            };
        case UPDATE_CHASSIDATA:
            if(!payload[0])
                state = defaultState    
            return {
                    ...state,              
                    chassiSearchList: payload.Results,
                    errors: payload.Errors,
                    pageInitialized:false
                };   
        case UPDATE_CHASSILOADING:            
            return {   
                ...state,          
                isloading:payload,
            };  
        case ERROR_CHASSIDATA:             
        return {   
                ...state,          
                isDataerror:payload,
            }; 
        case CLEAR_CHASSIDATA:
            return{
                isloading:false,
                chassiSearchList:[],
                errors: [],
                pageInitialized:true
            }      
        default:
            return state;
    }
};
